import styled from "@emotion/styled";
import { TableCell } from "@kaltura/ds-react-components";

/**
 * Table cell that shrinks to the width of the contents.
 * Displays the contents in one line (except for mobile).
 */
export const FitContentTableCell = styled(TableCell)(({ theme }) => ({
    // That's the minimal width - table layout will expand it to the actual content width
    width: 50,
    [theme.breakpoints.up("sm")]: {
        whiteSpace: "nowrap",
    },
}));
